import styled from 'styled-components';

export const BrowseSection = styled.div`
  background: linear-gradient(
    to left,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);

  @media (min-width: 1024px) {
    width: 75%;
    margin: 0 auto;
    display: block;
  }

  @media (max-width: 720px) {
    padding: ${(props) =>
      props.showNewCDDDPage ? '0 0 20px 0' : props.padding ? '5px 0' : '0'};
    margin: 10px 0px 50px 0px;
  }

  &.shakeanimation {
    animation: shakeButton 1s ease;

    @keyframes shakeButton {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
  }
`;

export const SectionHeading = styled.div`
  position: relative;
  .textWrapper {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  @media (min-width: 1024px) {
    .textWrapper {
      width: 100%;
    }
  }
`;

export const BannerTitle = styled.div`
  width: 60%;
  font-size: 18px;
  color: #ffffff;
  font-weight: 600;
  span {
    color: #643491;
  }
`;

export const BannerSubTitle = styled.div`
  width: 70%;
  color: #ffffff;
  font-size: 12px;
  span {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 600;
  }
`;

export const RelativeDiv = styled.div`
  position: relative;
  margin-left: 3px;
`;

export const ProductCardPrice = styled.div`
  padding: 8px 5px 5px 5px;
  margin-top: 5px;

  &.ios-device h4 {
    min-height: 40px;
  }

  @media (max-width: 720px) {
    margin-top: ${(props) => (props.showNewCDDDPage ? '0px' : '')};
    &.ios-device h4 {
      min-height: ${(props) => (props.showNewCDDDPage ? '0px' : '40px')};
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 190px;
  @media (max-width: 720px) {
    width: ${(props) => (props.showNewCDDDPage ? '133px' : '100%')};
    height: ${(props) => (props.showNewCDDDPage ? '133px' : '190px')};
  }
  box-sizing: border-box;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px 5px 0px 0px;
  object-fit: cover;
  box-sizing: border-box;
  display: block;
  @media (max-width: 720px) {
    border-radius: ${(props) =>
      props.showNewCDDDPage ? '5px 0px 0px 5px' : '5px 5px 0px 0px'};
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: ${(props) => (props.isLocked ? 1 : 0)};
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 4px 4px 0px 0px;

  p {
    color: #fff;
    font-size: 11px;
    margin-top: 5px;
  }

  @media (max-width: 720px) {
    border-radius: ${(props) =>
      props.showNewCDDDPage ? '4px 0px 0px 4px' : '4px 4px 0px 0px'};
    p {
      font-size: ${(props) => (props.showNewCDDDPage ? '10px' : '11px')};
      width: ${(props) =>
        props.outOfStockProduct ? '100%' : props.showNewCDDDPage ? '90%' : ''};
    }
  }
`;

export const Card = styled.div`
  width: 180px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 #00000029;
  margin: 4px auto;
  margin-top: 10px;
  background-color: #fff;

  & h4 {
    font-size: 14px;
    font-weigt: 600;
    color: rgba(0, 0, 0, 0.87);
  }

  @media (max-width: 720px) {
    width: 95%;
    display: ${(props) => (props.showNewCDDDPage ? 'flex' : '')};
    gap: ${(props) => (props.showNewCDDDPage ? '10px' : '')};
  }
`;

export const ProductAge = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.87);
  margin: 5px 0;
`;

export const ProductPrice = styled.div`
  display: flex;
  align-items: baseline;
  margin: 10px 0;
  & .span {
    padding-left: 9px;
  }
  @media (max-width: 720px) {
    margin: ${(props) => (props.showNewCDDDPage ? '5px 0' : '10px 0')};
  }
`;

export const TotalAmount = styled.span`
  font-weight: 600;
  color: hsl(0deg 0% 0% / 87%);
  font-size: ${(props) => (props.card ? '15px' : '20px')};
`;

export const InclTax = styled.div`
    font-size: 10px;
    color: rgb(0 0 0 / 54%);
    font-weight: 500;
    padding:  font-size: ${(props) => (props.perUnit ? '0 0 2px' : '')};
`;

export const InclTaxNew = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
  font-weight: 500;
  margin-left: 12px;
`;

export const MRPname = styled.span`
  color: hsl(0deg 0% 0% / 40%);
  font-size: 14px;
  font-weight: 500;
  padding-right: 2px;
`;

export const StrikePrice = styled.span`
  color: hsl(0deg 0% 0% / 40%);
  font-size: 13px;
  text-decoration: line-through;
  font-weight: 500;
`;
export const Discount = styled.p`
  font-size: 12px;
  color: hsl(174deg 33% 54%);
  text-decoration: none;
  font-weight: 700;
`;

export const AddButton = styled.div`
  margin: 5px 3px;
  font-size: 13px;
  color: ${(props) => (props.addedToCart ? 'rgba(0, 0, 0, 0.38);' : '#ef4e5e')};
  font-weight: 600;
  background-color: #fff;
  padding: 6px 12px;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  cursor: pointer;
  text-align: center;
  border: ${(props) =>
    props.addedToCart ? '1px solid rgba(0, 0, 0, 0.38)' : '1px solid #ef4e5e'};
  white-space: nowrap;
  opacity: ${(props) => (props.outOfStockProduct ? '0.2' : '1')};
  @media (max-width: 720px) {
    margin: ${(props) => (props.showNewCDDDPage ? '4px 3px' : '5px 3px')};
    color: ${(props) =>
      props.addedToCart
        ? 'rgba(0, 0, 0, 0.38)'
        : props.showNewCDDDPage
          ? '#fff'
          : '#ef4e5e'};
    background-color: ${(props) =>
      props.addedToCart ? '#fff' : props.showNewCDDDPage ? '#ef4e5e' : '#fff'};
    padding: ${(props) => (props.showNewCDDDPage ? '5px 8px' : '6px 12px')};
    width: ${(props) => (props.showNewCDDDPage ? '130px' : '')};
  }
`;

export const RatingSectionNew = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-bottom: 10px;
  margin-top: 15px;
  @media (max-width: 720px) {
    margin-top: ${(props) => (props.showNewCDDDPage ? '4px' : '9px')};
    margin-bottom: ${(props) => (props.showNewCDDDPage ? '5px' : '')};
  }

  img {
    width: 14px;
  }
  p {
    font-weight: 500;
    font-size: clamp(14px, 2vw, 16px);
  }
  span {
    color: #898989bd;
    font-weight: 500;
    font-size: clamp(12px, 2vw, 14px);
  }
`;
